import { eFoodDB } from "pwa/db/efood.db";
import productsSyncTimestamp from "./productsSyncTimestamp";

const clearProductsData = () =>
  Promise.all([productsSyncTimestamp.clear(), eFoodDB.products.clear()]);

export default clearProductsData;
